import React, { useState } from 'react';
import { Download, FileSpreadsheet, FileText, Loader2 } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const ExportButton = ({ 
  onExportExcel, 
  onExportPDF, 
  excelLabel = "Export Excel",
  pdfLabel = "Export PDF",
  showExcel = true,
  showPDF = true
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(null);

  const handleExport = async (type, handler) => {
    setLoading(type);
    try {
      await handler();
    } catch (error) {
      console.error(`${type} export failed:`, error);
    } finally {
      setLoading(null);
      setIsOpen(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="export-button"
        className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-all
          ${isDark 
            ? 'bg-white/5 text-slate-300 hover:bg-white/10 border border-white/10' 
            : 'bg-slate-100 text-slate-700 hover:bg-slate-200 border border-slate-200'
          }`}
      >
        <Download className="w-4 h-4" />
        Export
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className={`absolute right-0 top-full mt-2 z-50 rounded-xl border shadow-xl overflow-hidden min-w-[180px]
            ${isDark ? 'bg-[#1a1a1c] border-white/10' : 'bg-white border-slate-200'}`}
          >
            {showExcel && onExportExcel && (
              <button
                onClick={() => handleExport('excel', onExportExcel)}
                disabled={loading === 'excel'}
                data-testid="export-excel-btn"
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors
                  ${isDark 
                    ? 'text-slate-300 hover:bg-white/5' 
                    : 'text-slate-700 hover:bg-slate-50'
                  } ${loading === 'excel' ? 'opacity-50' : ''}`}
              >
                {loading === 'excel' ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <FileSpreadsheet className="w-4 h-4 text-emerald-500" />
                )}
                {excelLabel}
              </button>
            )}
            {showPDF && onExportPDF && (
              <button
                onClick={() => handleExport('pdf', onExportPDF)}
                disabled={loading === 'pdf'}
                data-testid="export-pdf-btn"
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors
                  ${isDark 
                    ? 'text-slate-300 hover:bg-white/5' 
                    : 'text-slate-700 hover:bg-slate-50'
                  } ${loading === 'pdf' ? 'opacity-50' : ''}`}
              >
                {loading === 'pdf' ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <FileText className="w-4 h-4 text-red-500" />
                )}
                {pdfLabel}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ExportButton;
